import { useEffect } from 'react';
import { RightOutlined } from '@ant-design/icons';
import './index.scss';

export default function OrganizationItem(props) {
    const { itemData, className, click } = props;

    useEffect(() => {}, []);

    return (
        <div className={`organization-item ${className}`} onClick={click}>
            {itemData.url ? (
                <img className="user-avatar" src={itemData.url} />
            ) : (
                <p className={`user-avatar text-avatar ${itemData.roleClass}`}>
                    {itemData.roleName?.[0]}
                </p>
            )}
            <div className="item-content">
                <h4 className="text-no-wrap" title={itemData.name}>
                    {itemData.name || '--'}
                </h4>
                <p className="text-no-wrap" title={itemData.roleName}>
                    {itemData.roleName}
                </p>
            </div>
            <RightOutlined style={{ color: '#999' }} />
        </div>
    );
}
